import React from "react";
import i18n from "../../../../../../constants/i18n";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getInvestigationCasesStore from "../../../../../../stores/investigation-cases-store";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import { getPermissionIDRequired } from "../../../../../../helpers/et3-has-permission";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";

const UnderCSRInvestigation = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const {
    userIsUnderCsrInvestigation,
    userUnderInvestigationAndReadyToResolve
  } = advancedStore.currentUserIsUnderCsrInvestigation.get();
  const currentUserIsUnderCsrReport =
    advancedStore.currentUserIsUnderCsrReport.get();
  const isUnderCsrInvestigationEnabled =
    userIsUnderCsrInvestigation && !currentUserIsUnderCsrReport;

  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const userID = advancedStore.currentUserId.get();
  const hasInvestigationPermission =
    getCorePersonalStore()
      .userPermissions.get()
      .indexOf(getPermissionIDRequired("Investigation-Case")) > -1;

  return isAnyKhattabaAdmin ? null : (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={230}
        height={36}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={
          isUnderCsrInvestigationEnabled ? colors.all.orange : colors.all.gray
        }
        style={{
          borderRadius: 20,
          cursor: "pointer"
        }}
        onClick={() => {
          console.warn(
            "iam here",
            isUnderCsrInvestigationEnabled,
            userIsUnderCsrInvestigation,
            userUnderInvestigationAndReadyToResolve
          );

          if (
            userIsUnderCsrInvestigation &&
            !userUnderInvestigationAndReadyToResolve
          ) {
            getCorePopUpStore().showAlertMessage(
              "USER_UNDER_CSR_INVESTIGATION_BUT_WILL_APPEAR_SOON"
            );
            return;
          }
          if (isUnderCsrInvestigationEnabled && hasInvestigationPermission) {
            getInvestigationCasesStore().getInvestigationCaseByID({
              userID
            });
          }
        }}
      >
        <Et3Text
          text={i18n.get("UNDER_CSR_INVESTIGATION_STATUS")}
          fontFamily="BOLD"
          fontSize={15}
          color={colors.all.white}
          isSpan={true}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={10} bottom={0} left={0} right={0} />
    </React.Fragment>
  );
});
export default UnderCSRInvestigation;
